import { render, staticRenderFns } from "./AccountingPointOtherEquipmentTable.vue?vue&type=template&id=b8f80500&"
import script from "./AccountingPointOtherEquipmentTable.vue?vue&type=script&lang=ts&"
export * from "./AccountingPointOtherEquipmentTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports